document.querySelectorAll(".language-toggle_").forEach(function (toggle) {
    toggle.addEventListener("click", function (event) {
        event.stopPropagation();
        let dropdown = this.nextElementSibling;

        if (dropdown && dropdown.classList.contains("language-dropdown1")) {
            dropdown.classList.toggle("show");
        }
    });
});

document.addEventListener("click", function () {
    document.querySelectorAll(".language-dropdown1.show").forEach(function (dropdown) {
        dropdown.classList.remove("show");
    });
});

document.querySelectorAll(".language-dropdown1").forEach(function (dropdown) {
    dropdown.addEventListener("click", function (event) {
        event.stopPropagation();
    });
});



document.querySelectorAll(".language-dropdown1 a").forEach(function (link) {
    link.addEventListener("click", function (event) {
        event.preventDefault();

        let selectedLang = link.getAttribute("data-value");
        document.querySelectorAll(".disclosure__list .disclosure__link").forEach(function (disclosureLink) {
            if (disclosureLink.getAttribute("data-value") === selectedLang) {
                disclosureLink.click();
            }
        });
    });
});

// document.getElementById("Subscribe").addEventListener("mouseenter", function () {
//     let emailInput = document.getElementById("NewsletterForm--latest_footer").value;
//     let tooltip = document.getElementById("tooltip");

//     if (emailInput.includes("@")) {
//         tooltip.style.display = "block";
//     }
// });

// document.getElementById("Subscribe").addEventListener("mouseleave", function () {
//     document.getElementById("tooltip").style.display = "none";
// });